<template>
  <ubi-page-container wide-main-content>
    <div v-loading="loading" :element-loading-text="$t('portals.list.chargementDonnees')">
    <el-form label-position="top" @submit.prevent.native="fetchList">
      <ubi-panel class="PortalsSocialManagment">
        <template slot="header">
          <span style="color: #3f7785; font-size: .8125rem;">{{ $t('portals.list.results') }}: {{ results.count }}</span>
        </template>
        <el-table ref="tablePortalsList" :data="results.list" v-if="browserContext.up('lg')">
          <el-table-column fixed :label="$t('portals.list.columnActivate')" min-width="80">
            <template v-slot="{ row: result }">
              <em class="el-icon-success text-success mr-2" style="font-size:1.9em;" v-if="result.active" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.list.columnLogo')" min-width="140">
            <template v-slot="{ row: result }">
              <img alt="" width="70" :src="result._embedded.diffuseur.logo" :srcset="result._embedded.diffuseur.logo" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.list.columnPortal')" min-width="250">
            <template v-slot="{ row: result }">
              <span v-if="result._embedded.diffuseur.prive === false">
                  <el-link target="_blank" rel="noopener" :href="result._embedded.diffuseur.lienSiteUbiflow"> {{ result._embedded.diffuseur.nom }}</el-link>
              </span>
              <span v-else>
                {{ result._embedded.diffuseur.nom }}
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.list.columnSelectAds')" min-width="150" align="center">
            <template v-slot="{ row: result }">
              <router-link v-if=" result.active === true" :to="{ name: 'broadcast', params: { portal: result.id } }">
                <em class="el-icon-edit"></em>
              </router-link>
              <div v-else>-</div>
            </template>
          </el-table-column>
        </el-table>
      </ubi-panel>
    </el-form>
    </div>
  </ubi-page-container>
</template>

<style lang="scss">
@import "@/theme/_bootstrap.scss";
.el-table-column--selection {
  width: 70px;
}
.el-loading-spinner{
  top:10%!important;
}
</style>

<script>
import { mapState, mapMutations } from 'vuex'
import { getPortals } from '@/services/portals'
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'

export default {
  name: 'PortalsSocialManagment',
  components: { UbiPanel, UbiPageContainer },
  inject: ['browserContext'],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('portalsSocialManagment', ['results']),
    sitimmoUser () {
      return this.$store.state.sitimmoUser
    }
  },
  beforeMount () {
    this.fetchList()
  },
  methods: {
    ...mapMutations('portalsSocialManagment', ['setResults']),
    async fetchList () {
      this.loading = true
      this.filters = {}
      this.filters.active = true
      this.filters.category = 'réseaux sociaux'
      this.filters.limit = 100
      this.filters.page = 1
      const portails = await getPortals(this.filters)
      if (portails.type == 'error') {
        this.loading = false
        return false
      }
      this.setResults(portails)
      this.loading = false
    }
  }
}
</script>
